import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IComponentsRegistrar } from '@wix/thunderbolt-components-loader'

export const ContentReflowBannerRegistrar = withDependencies([], (): IComponentsRegistrar => {
	return {
		getComponents() {
			return {
				// The cast strips nodenext's CJS-interop `{ default: <module> }` model of sibling import();
				// webpack loads this chunk with ESM namespace semantics, which is exactly the type-position
				// `typeof import(...)` shape. See NodeModeledComponentModule in @wix/thunderbolt-components-loader.
				ContentReflowBanner: () =>
					(
						import(
							'./viewer/ContentReflowBanner.js' /* webpackChunkName: "ContentReflowBanner" */
						) as unknown as Promise<typeof import('./viewer/ContentReflowBanner.js')>
					).then((componentModule) => {
						return {
							component: componentModule.default,
						}
					}),
			}
		},
	}
})
